export const BOOT_SPLASH_ELEMENT_ID = 'boot-splash';
export const BOOT_SPLASH_HIDDEN_CLASS = 'boot-splash--hidden';
export const BOOT_SPLASH_FADE_MS = 200;
